import { render, staticRenderFns } from "./consumptionDetails.vue?vue&type=template&id=6b36c7f2&scoped=true&"
import script from "./consumptionDetails.vue?vue&type=script&lang=js&"
export * from "./consumptionDetails.vue?vue&type=script&lang=js&"
import style0 from "./consumptionDetails.vue?vue&type=style&index=0&id=6b36c7f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b36c7f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b36c7f2')) {
      api.createRecord('6b36c7f2', component.options)
    } else {
      api.reload('6b36c7f2', component.options)
    }
    module.hot.accept("./consumptionDetails.vue?vue&type=template&id=6b36c7f2&scoped=true&", function () {
      api.rerender('6b36c7f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/consumptionDetails.vue"
export default component.exports